import { loginUser, loginOrg, getAuthorityInfo } from './LoginContext';
import { checkPermissions } from '@/components/Authorized/CheckPermissions';

// use localStorage to store the authority info, which might be sent from server in actual project.
export function getAuthority(str) {
  // return localStorage.getItem('antd-pro-authority') || ['admin', 'user'];
  const authorityString =
    // typeof str === 'undefined' ? localStorage.getItem('antd-pro-authority') : str;
    typeof str === 'undefined' ?getAuthorityInfo() : str;
  // authorityString could be admin, "admin", ["admin"]
  let authority;
  try {
    authority = JSON.parse(authorityString);
  } catch (e) {
    authority = authorityString;
  }
  if (typeof authority === 'string') {
    return [authority];
  }
  return authority || ['admin'];
}

/**
 * 判断有没有权限
 * 
 * @param {String, Array} currentResource 当前要检测的资源，可以是字符串和数组
 */
export function havePermission(currentResource) {
  if (loginOrg() && loginOrg().type === 'HEADING') {
    return true;
  }

  let allResources = loginUser() ? loginUser().resources : [];
  if (!allResources || allResources.length === 0)
    return false;
    
  let result = checkPermissions(currentResource, allResources, true, null);
  return result === true;
}
